<lib-page-layout>
  <lib-title-navbar pageHeader title="Statystyki Użytkowników"></lib-title-navbar>
  <div class="stats-page">
    @if (summary(); as summaryData) {
      <div class="stats-card stats-card--highlight">
        <div class="stats-card__value">{{ summaryData.totalUsers }}</div>
        <div class="stats-card__label">Wszyscy użytkownicy</div>
      </div>

      <div class="accordion" [class.accordion--open]="registrationsOpen()">
        <button class="accordion__header" (click)="toggleRegistrations()">
          <span class="accordion__title">Dzienne rejestracje</span>
          <img
            [src]="registrationsOpen() ? 'assets/icons/chevron-up.svg' : 'assets/icons/chevron-down-primary.svg'"
            class="accordion__chevron" />
        </button>
        <div class="accordion__collapse">
          <div class="accordion__body">
            <lib-days-range-slider [value]="statsDays()" (valueChange)="setPeriod($event)"></lib-days-range-slider>
            <div class="view-selector">
              <button
                class="view-btn"
                [class.view-btn--active]="registrationsViewMode() === RegistrationsViewMode.BY_DAY"
                (click)="setRegistrationsViewMode(RegistrationsViewMode.BY_DAY)">
                Wg dnia
              </button>
              <button
                class="view-btn"
                [class.view-btn--active]="registrationsViewMode() === RegistrationsViewMode.BY_REGION"
                (click)="setRegistrationsViewMode(RegistrationsViewMode.BY_REGION)">
                Wg regionu
              </button>
            </div>
            <div class="registrations-count">Łącznie: {{ registrationsTotal() }}</div>

            @if (registrationsViewMode() === RegistrationsViewMode.BY_DAY) {
              <div class="registrations-list">
                @for (reg of summaryData.dailyRegistrations; track reg.rawDate) {
                  <div
                    class="registration-item registration-item--clickable"
                    [class.registration-item--expanded]="expandedDate() === reg.rawDate"
                    (click)="toggleDate(reg.rawDate)">
                    <div class="registration-item__date">
                      <span>{{ reg.date }}</span>
                      <span class="registration-item__day">{{ reg.dayOfWeek }}</span>
                    </div>
                    <div class="registration-item__right">
                      <span class="registration-item__count">{{ reg.count }}</span>
                      @if (reg.regions.length) {
                        <img
                          [src]="
                            expandedDate() === reg.rawDate
                              ? 'assets/icons/chevron-up.svg'
                              : 'assets/icons/chevron-down-primary.svg'
                          "
                          class="registration-item__chevron" />
                      }
                    </div>
                  </div>
                  @if (expandedDate() === reg.rawDate && reg.regions.length) {
                    <div class="region-breakdown">
                      @for (region of reg.regions; track region.regionName) {
                        <div class="region-breakdown__item">
                          <span class="region-breakdown__name">{{ region.regionName }}</span>
                          <span class="region-breakdown__count">{{ region.count }}</span>
                        </div>
                      }
                    </div>
                  }
                } @empty {
                  <div class="stats-empty">Brak danych</div>
                }
              </div>
            } @else {
              <div class="registrations-list">
                @for (region of summaryData.registrationsByRegion; track region.regionName) {
                  <div
                    class="registration-item registration-item--clickable"
                    [class.registration-item--expanded]="expandedRegion() === region.regionName"
                    (click)="toggleRegion(region.regionName)">
                    <div class="registration-item__date">
                      <span>{{ region.regionName }}</span>
                    </div>
                    <div class="registration-item__right">
                      <span class="registration-item__count">{{ region.total }}</span>
                      <img
                        [src]="
                          expandedRegion() === region.regionName
                            ? 'assets/icons/chevron-up.svg'
                            : 'assets/icons/chevron-down-primary.svg'
                        "
                        class="registration-item__chevron" />
                    </div>
                  </div>
                  @if (expandedRegion() === region.regionName) {
                    <div class="region-breakdown">
                      @for (day of region.dailyRegistrations; track day.rawDate) {
                        <div class="region-breakdown__item">
                          <span class="region-breakdown__name"
                            >{{ day.date }}
                            <span class="region-breakdown__day">{{ day.dayOfWeek }}</span>
                          </span>
                          <span class="region-breakdown__count">{{ day.count }}</span>
                        </div>
                      }
                    </div>
                  }
                } @empty {
                  <div class="stats-empty">Brak danych</div>
                }
              </div>
            }
          </div>
        </div>
      </div>

      <div class="accordion" [class.accordion--open]="regionsOpen()">
        <button class="accordion__header" (click)="toggleRegions()">
          <span class="accordion__title">Regiony</span>
          <img
            [src]="regionsOpen() ? 'assets/icons/chevron-up.svg' : 'assets/icons/chevron-down-primary.svg'"
            class="accordion__chevron" />
        </button>
        <div class="accordion__collapse">
          <div class="accordion__body">
            <div class="registrations-list">
              @for (region of summaryData.regionStats; track region.regionName) {
                <div class="registration-item">
                  <span class="registration-item__date">{{ region.regionName }}</span>
                  <span class="registration-item__count">{{ region.userCount }}</span>
                </div>
              } @empty {
                <div class="stats-empty">Brak danych</div>
              }
            </div>
          </div>
        </div>
      </div>

      <div class="accordion" [class.accordion--open]="platformsOpen()">
        <button class="accordion__header" (click)="togglePlatforms()">
          <span class="accordion__title">Platformy i wersje</span>
          <img
            [src]="platformsOpen() ? 'assets/icons/chevron-up.svg' : 'assets/icons/chevron-down-primary.svg'"
            class="accordion__chevron" />
        </button>
        <div class="accordion__collapse">
          <div class="accordion__body">
            <div class="stats-grid">
              @for (platform of summaryData.platformStats; track platform.platform) {
                <div class="stats-item">
                  @if (platform.icon) {
                    <img [src]="platform.icon" class="stats-item__icon" [alt]="platform.platform" />
                  }
                  <div class="stats-item__data">
                    <div class="stats-item__value">{{ platform.count }}</div>
                    <div class="stats-item__label">{{ platform.platform }}</div>
                  </div>
                </div>
              }
            </div>
            <div class="versions-section-title">Wersje aplikacji</div>
            <div class="versions-list">
              @for (version of versions(); track version.version) {
                <div class="version-item">
                  <span class="version-item__name">v{{ version.version }}</span>
                  <div class="version-item__platforms">
                    <span class="version-item__platform">
                      <img src="assets/icons/apple.svg" class="version-item__platform-icon" alt="iOS" />
                      {{ version.iosCount }}
                    </span>
                    <span class="version-item__platform">
                      <img src="assets/icons/android.svg" class="version-item__platform-icon" alt="Android" />
                      {{ version.androidCount }}
                    </span>
                  </div>
                  <span class="version-item__count">{{ version.count }}</span>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    }
  </div>
</lib-page-layout>
